import { useEffect, useState } from "react";
import { BOOK } from "@/data/book";

export default function TableOfContents({ activeId, onSelect }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const scrolled = h.scrollTop / (h.scrollHeight - h.clientHeight);
      setProgress(Math.min(1, Math.max(0, scrolled)));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
    // All referenced names (onScroll, h, scrolled) are local to this effect; no real closure deps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <aside data-testid="toc-sidebar" className="hidden lg:block">
      <div className="sticky top-24">
        <p className="font-ui text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
          Thirteen Truths
        </p>
        <div className="h-1 w-full bg-muted rounded-full overflow-hidden mb-6">
          <div
            className="h-full bg-primary transition-[width] duration-150"
            style={{ width: `${progress * 100}%` }}
            data-testid="toc-progress"
          />
        </div>
        <nav className="space-y-1">
          <button
            onClick={() => onSelect("before-you-begin")}
            data-testid="toc-link-intro"
            className={`block w-full text-left font-ui text-sm py-2 px-3 rounded-md transition-colors ${
              activeId === "before-you-begin" ? "bg-primary/10 text-primary font-semibold" : "text-foreground/75 hover:bg-muted"
            }`}
          >
            <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground block">Prologue</span>
            Before You Begin
          </button>
          {BOOK.chapters.map((ch) => (
            <button
              key={ch.id}
              onClick={() => onSelect(ch.id)}
              data-testid={`toc-link-${ch.id}`}
              className={`block w-full text-left font-ui text-sm py-2 px-3 rounded-md transition-colors ${
                activeId === ch.id ? "bg-primary/10 text-primary font-semibold" : "text-foreground/75 hover:bg-muted"
              }`}
            >
              <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground block">
                Truth {String(ch.number).padStart(2, "0")}
              </span>
              {ch.title}
            </button>
          ))}
          <button
            onClick={() => onSelect("in-closing")}
            data-testid="toc-link-closing"
            className={`block w-full text-left font-ui text-sm py-2 px-3 rounded-md transition-colors ${
              activeId === "in-closing" ? "bg-primary/10 text-primary font-semibold" : "text-foreground/75 hover:bg-muted"
            }`}
          >
            <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground block">Epilogue</span>
            In Closing
          </button>
        </nav>
      </div>
    </aside>
  );
}
